"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const msGraphToolRegistry = {
  getCalendarEvents: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./get-calendar-events").then(({ GetCalendarEventsToolView }) => ({
        default: GetCalendarEventsToolView,
      }))
    ),
  },
  listSharedCalendars: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./list-shared-calendars").then(
        ({ ListSharedCalendarsToolView }) => ({
          default: ListSharedCalendarsToolView,
        })
      )
    ),
  },
  // `findMeetingTimes` / `getSchedule` moved to the `meeting-logistics`
  // capability — their views are registered in `../meeting-logistics/registry`
  // (the view files stay here, shared with the calendar grid).
  getMeetingsWithTranscripts: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./get-meetings-with-transcripts").then(
        ({ GetMeetingsWithTranscriptsToolView }) => ({
          default: GetMeetingsWithTranscriptsToolView,
        })
      )
    ),
  },
  getMeetingTranscript: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./get-meeting-transcript").then(
        ({ GetMeetingTranscriptToolView }) => ({
          default: GetMeetingTranscriptToolView,
        })
      )
    ),
  },
  // The mailbox views moved to the `mailbox` capability — they're registered
  // in `../mailbox/registry` (the view files stay here in `mail-views`). The
  // OneNote views did the same into `../onenote-graph/registry`, with their
  // view files staying here in `onenote-views`.
} satisfies ToolUIRegistry;
